import { Component, ViewChild, ElementRef, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { BillBatchService } from "app/open-api/api/billBatch.service";
import { BillService } from 'app/open-api';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { environment } from "environments/environment";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from 'ngx-spinner';
import { CSVBillRQ } from "app/open-api/model/csvBillRQ";
import { CSVBillRP, SenderBillModel, CustomerBillModel, IdCode } from "app/open-api/model/csvBillRP";
import { TemporaryBillRQ } from "app/open-api/model/temporaryBillRQ";
import { ProccessTemporaryBills, ProccessSingleTemporaryBill } from "app/open-api/model/proccessTemporaryBills";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import Swal from 'sweetalert2';
import { DownloadPdfRQ } from "app/open-api/model/downloadPdfRQ";
import { BillOperationRP, GetBillOperationsRP } from "app/open-api/model/billOperation";
import { NgbDateStruct, NgbDatepicker, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TemporaryBillsComponent } from '../temporary-bills/temporary-bills.component';
import { AuthService } from '../../authentication/services/auth.service';
import { GetBillBatchRP } from '../../open-api/model/getBillBatchRP';


@Component({
  selector: "app-bill-batch-create",
  templateUrl: "./bill-batch-create.component.html",
  styleUrls: ["./bill-batch-create.component.scss"],
})
export class BillBatchCreateComponent implements OnInit {
  @ViewChild("popOver") public popover: NgbPopover;
  public basicSelectedOption: number = 5;
  public bills: CSVBillRP[] = [];
  public searchBills: CSVBillRP[] = [];
  selectedBills: CSVBillRP[] = [];
  selectedBill: CSVBillRP;
  operationId: number;
  temporaryOperations: BillOperationRP[] = [];
  isAdmin: boolean = false;
  public generalResults: string = "Aún no se ha cargado el fichero.";
  public alreadyRegisteredBillsMsg: string = "";
  public rows: any[] = [];
  selected = [];
  public ColumnMode = ColumnMode;
  urlApi = environment.apiUrl;
  public SelectionType = SelectionType;
  canCheck = false;
  buttonDisabled;
  checkboxedSkus: any;
  allRowsSelected: any;
  currentStep: number = 1;
  searched = false;
  withPdf: boolean;
  clickedBill: string = "-1";
  tooltipDefaultMsg: string = "Click para ver detalles";
  tooltipClickedMsg: string = "";
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private _billBatchService: BillBatchService,
    private _billService: BillService,
    private _location: Location,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private _authenticationService: AuthService
  ) {}

  OpenHistoryModal() {
    const modalRef = this.modalService.open(TemporaryBillsComponent, {
      windowClass: 'modal',
      size: 'lg'
    });
    modalRef.componentInstance.operations = this.temporaryOperations;
    modalRef.result.then(result => {
     // this.FetchModels();
    });
  }

  onFileSelected(event: any) {
    this.resetSearch();
    if (event) {
      const swal = Swal.fire({
        title: "Escoja la opción de procesamiento de facturas.",
        text: "Tenga en cuenta que si escoje la opción sin pdf no podrá consultar esa información en el futuro.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Con PDF",
        cancelButtonText: "Sin PDF",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.withPdf = true;
          const param: GetBillBatchRP = {
            file : event.target.files[0],
            withPdf: 1
          }
          //this.resetSearch();
          this.currentStep = 2;
          this.spinner.show();
    
          let errors = [];
          // try {
          //this.spinner.show();
          this._billBatchService.apiBillBatchTemporaryListPost(param).subscribe(
            (response) => {            
              this.bills = [];
              this.generalResults = `Resultados de la carga de facturas temporales desde el excel.`;
              let list = response.loadBills;
              let errorCount = response.totalErrors;
              let succesCount = response.totalSuccess;
              let totalRecords = response.totalRecords;
              this.canCheck = succesCount > 0;
              this.operationId = response.id;
              let cntErrors = 0;
              if (list)
                list.forEach((row) => {
                  let message = "";
                  if (row.errors.length > 0) {
                    row.errors.forEach((errorRow) => {
                      message += ` ${errorRow.message}`;
                    });
                  } else message = "Factura registrada satisfactoriamente.";
    
                  let now: CSVBillRP = this.GetCSVBillRPFromRQ(row, message);
                  this.searchBills = this.bills = this.bills.concat(now);
                });            
    
              if (totalRecords > 0) {
                this.alreadyRegisteredBillsMsg = `Se guardaron temporalmente ${succesCount} registros válidos y ${errorCount} con errores.`;
              } else {
                this.alreadyRegisteredBillsMsg = `No se guardaron registros.`;
              }
    
              let cntAlreadyOnDatabase = 0;
              let errorNotCatched = false;
    
              errors.forEach((error) => {
                if (
                  error.message ===
                  "La factura ya se encuentra en la base de datos."
                ) {
                  cntAlreadyOnDatabase = cntAlreadyOnDatabase + 1;
                } else if (
                  error.message === "Se encontraron errores al procesar el archivo."
                )
                  errorNotCatched = true;
              });
    
              if (cntAlreadyOnDatabase > 0) {
                this.alreadyRegisteredBillsMsg = `Se omitieron ${cntAlreadyOnDatabase} facturas que ya estaban registradas.`;
              }
    
              if (errorNotCatched)
                this.generalResults =
                  "Se encontraron errores al procesar el archivo.";
             this.getTemporaryOperations();
              this.spinner.hide();
            },
            (error) => {
              this.currentStep = 1;
              console.log("error")
              Swal.fire({
                title: "Error! " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 5000,
                position: "top",
              });
              this.spinner.hide();
            }
          );        
        event.target.value = ''  
        }
        else if (result.isDismissed){
          this.withPdf = false;
          const param: GetBillBatchRP = {
            file : event.target.files[0],
            withPdf: 2
          }
          //this.resetSearch();
          this.currentStep = 2;
          this.spinner.show();
    
          let errors = [];
          // try {
          //this.spinner.show();
          this._billBatchService.apiBillBatchTemporaryListPost(param).subscribe(
            (response) => {            
              this.bills = [];
              this.generalResults = `Resultados de la carga de facturas temporales desde el excel.`;
              let list = response.loadBills;
              let errorCount = response.totalErrors;
              let succesCount = response.totalSuccess;
              let totalRecords = response.totalRecords;
              this.canCheck = succesCount > 0;
              this.operationId = response.id;
              let cntErrors = 0;
              if (list)
                list.forEach((row) => {
                  let message = "";
                  if (row.errors.length > 0) {
                    row.errors.forEach((errorRow) => {
                      message += ` ${errorRow.message}`;
                    });
                  } else message = "Factura registrada satisfactoriamente.";
    
                  let now: CSVBillRP = this.GetCSVBillRPFromRQ(row, message);
                  this.searchBills = this.bills = this.bills.concat(now);
                });            
    
              if (totalRecords > 0) {
                this.alreadyRegisteredBillsMsg = `Se guardaron temporalmente ${succesCount} registros válidos y ${errorCount} con errores.`;
              } else {
                this.alreadyRegisteredBillsMsg = `No se guardaron registros.`;
              }
    
              let cntAlreadyOnDatabase = 0;
              let errorNotCatched = false;
    
              errors.forEach((error) => {
                if (
                  error.message ===
                  "La factura ya se encuentra en la base de datos."
                ) {
                  cntAlreadyOnDatabase = cntAlreadyOnDatabase + 1;
                } else if (
                  error.message === "Se encontraron errores al procesar el archivo."
                )
                  errorNotCatched = true;
              });
    
              if (cntAlreadyOnDatabase > 0) {
                this.alreadyRegisteredBillsMsg = `Se omitieron ${cntAlreadyOnDatabase} facturas que ya estaban registradas.`;
              }
    
              if (errorNotCatched)
                this.generalResults =
                  "Se encontraron errores al procesar el archivo.";
             this.getTemporaryOperations();
              this.spinner.hide();
            },
            (error) => {
              this.currentStep = 1;
              console.log("error")
              Swal.fire({
                title: "Error! " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 5000,
                position: "top",
              });
              this.spinner.hide();
            }
          );        
        event.target.value = ''  
        }
      })
      }
        
  }

  ngOnInit(): void {
    this.checkIsAdmin();
    //this.FetchModels();
    //this.getTemporaryOperations();
  }

  checkIsAdmin(){    
    this.isAdmin = this._authenticationService.isAdministrator;
  }

  onSelect({ selected }) {
    this.selectedBills = selected as CSVBillRP[];
    this.selectedBill = this.selectedBills[this.selectedBills.length - 1];
  }

  onActivate(event) {
    //console.log('Activate Event', event);
  }

  totalPounds(){    
    if(this.bills.length > 0){
      let sum = this.bills.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.pounds).toFixed(2));
      },0);   
      return sum; 
    }
    return 0;    
  }

  totalPaid(){
    let sum = this.bills.reduce((accumulator, item) => {
      return accumulator + Number(parseFloat(item.total).toFixed(2));
    },0);   
    return sum; 
  }

  onCheckboxChangeFn(event: any, code: string) {
   
  }

  resetSearch() {
    // you can access the input value via the following syntax.
    //console.log('this.searchInput', this.searchInput.nativeElement.value)
    this.searchInput.nativeElement.value = '';
  }

  //Ayuda a decidir el mensaje que se muestra como tooltip
  TooltipHelper(billId: string) { 
    if(!this.withPdf){      
       this.tooltipDefaultMsg = "La factura se cargó con la opción de no tener en cuenta los PDF."
    }      
    else {
      let result = this.bills.find(({ code }) => code === billId);
      if (result !== null && result !== undefined) {
        // console.log("result", result);
        let hasErrorPdf = result.errors.find(
          ({ message }) => message === "No existe un PDF asignado a la factura."
        );
  
        let hasErrorNoContent = result.errors.find(({ message }) =>
          message.includes("El excel no contiene")
        );
  
        if (hasErrorPdf !== null && hasErrorPdf !== undefined) {   
          if(this.withPdf){
            if (this.isAdmin && !this.CheckIfBillHasMoreThanOneError(billId))
              this.tooltipDefaultMsg =
                "No tiene pdf asociado. Pulse click para procesar la factura como administrador";
            else this.tooltipDefaultMsg = "No tiene pdf asociado.";
          }    
          else this.tooltipDefaultMsg = "La factura se cargó con la opción de no tener en cuenta los PDF."
          
        } else if (hasErrorNoContent !== null && hasErrorNoContent !== undefined) {
          this.tooltipDefaultMsg = "Factura con errores en el excel.";
        }
        else this.tooltipDefaultMsg = "Click para ver el pdf.";    
      }
    }   
    return this.tooltipDefaultMsg; 
  }

  DownloadPdf(billId: string) {
    //this.resetSearch();
    this.spinner.show();

    const hasError = this.CheckIfHasErrors(billId);

    if (hasError) {
      Swal.fire({
        title: `La factura no tiene pdf asociado.`,
        icon: "error",
        showConfirmButton: false,
        timer: 5000,
        position: "top",
      });
      this.spinner.hide();
    } else {
      this.clickedBill = billId;

      this._billService.apiDownloadPdfGet(billId).subscribe(
        (response) => {
          //console.log(`Se descargó satisfactoriamente el fichero "${billId}.pdf"`);
          const fileURL = URL.createObjectURL(response);
          window.open(fileURL, '_blank');
          
          Swal.fire({
            title: `El pdf se descargó satisfactoriamente.`,
            icon: "success",
            showConfirmButton: false,
            timer: 5000,
            position: "top",
          });
          this.spinner.hide();
          this.clickedBill = "-1";
        }, error => {
          //console.warn(error);
          Swal.fire({
            title: 'Error! ' + error.error,
            icon: 'error',
            showConfirmButton: false,
            timer: 5000,
            position: 'top'
          });
          this.spinner.hide();
        }        
      );
    }
  }

  getTemporaryOperations(){
    this.temporaryOperations = [];
    this.spinner.show();
    const param: GetBillOperationsRP = {
      
    };

    this._billService.getTemporaryOperations(param).subscribe(
      (response) => {
        this.temporaryOperations = response;             
        this.spinner.hide();
      },
      (error) => {
        //this.currentStep = 1;
        console.warn(error);

        Swal.fire({
          title: "Ha occurrido un error inesperado al obtener las operaciones.",
          icon: "error",
          showConfirmButton: false,
          timer: 5000,
          position: "top",
        });
        this.spinner.hide();
      }
    );
    
  }

  ProccessTemporaryBill() {
    this.resetSearch();
    this.spinner.show();
    const param: ProccessTemporaryBills = {
      IdBills: this.selectedBills.map((x) => x.id),
      proccessLastoperation: this.currentStep === 2,
      IdOperation: this.operationId,
    };

    this.currentStep = 3;
    this._billService.proccessTemporaryBill(param).subscribe(
      (response) => {
        if(response){
          this.canCheck = false;
          this.bills = [];
          this.selectedBills = [];
          //this.allBills = [];
          let message = "Ha iniciado el procesamiento de las facturas asociadas al archivo: " + response.fileName;
          this.generalResults = `Resultados del procesamiento de facturas temporales.`;
          this.alreadyRegisteredBillsMsg = message;
          Swal.fire({
            title: "Ha iniciado el procesamiento de las facturas asociadas al archivo: " + response.fileName,
            icon: "success",
            showConfirmButton: false,
            timer: 5000,
            position: "top",
          });
        }
        this.getTemporaryOperations();
        this.spinner.hide();
        //console.log('response', response);
        /*this.bills = [];
        let list = response;
        let errorCount = 0;
        let totalRecords = 0;
        let succesCount = 0;

        if (list) {
          totalRecords = list.length;
          list.forEach((row) => {
            //let error = errors.find(e => { return e.code === row.code })
            //let error =
            let message = "";
            if (row.errors.length > 0) {
              errorCount++;
              row.errors.forEach((errorRow) => {
                message += ` ${errorRow.message}`;
              });
            } else {
              message = "Factura registrada satisfactoriamente.";
              succesCount++;
            }

            //let now: CSVBillRP = this.GetCSVBillRPFromRQ(row, message);
            //console.log('now', now)
            this.searchBills = this.bills = [];
            this.selectedBills = [];
          });
        }

        if (totalRecords > succesCount) this.canCheck = succesCount > 0;
        else totalRecords == succesCount;
        this.canCheck = false;

        if (totalRecords > 0) {
          this.generalResults = `Resultados del procesamiento de facturas temporales.`;
          this.alreadyRegisteredBillsMsg = `Se guardaron ${succesCount} registros correctamente y ${errorCount} fueron rechazados por errores.`;
        } else {
          this.generalResults = `Resultados del procesamiento de facturas temporales.`;
          this.alreadyRegisteredBillsMsg = `No se procesaron registros.`;
        }

        //this.allBills = this.ModelParse(response.list);
        this.spinner.hide();*/
      },
      (error) => {
        this.currentStep = 1;
        console.warn(error);

        Swal.fire({
          title: "Ha occurrido un error inesperado al procesar las facturas.",
          icon: "error",
          showConfirmButton: false,
          timer: 5000,
          position: "top",
        });
        this.spinner.hide();
      }
    );
  }

  checkSelectable(event) {    
    return false;
  }

  public onCheckboxChange(event: any, row: any): void {    
  }

  public getChecked(row: any): boolean {    
    const item = this.selected.filter(
      (e) => e.id === row.id && e.site_code === row.site_code
    );
    return item.length > 0 ? true : false;
  }

  public CheckIfIsValid(codeSeek: IdCode): boolean {
    if (!this.canCheck) return true;

    let result = this.bills.find(({ id }) => id === codeSeek.id);
    if (result !== null && result !== undefined) {
      return !result.isValid;
    }
    return true;
  }

  public CheckIfBillHasPdf(codeSeek: string): boolean {
    let result = this.bills.find(({ code }) => code === codeSeek);
    if (result !== null && result !== undefined) {
      // console.log("result", result);
       let hasError = result.errors.find(
         ({ message }) => message === "No existe un PDF asignado a la factura."
       );

       if (hasError !== null && hasError !== undefined)         
           return true;      
    }
    return false;  
  }  

  public CheckIfBillHasMoreThanOneError(codeSeek: string): boolean {
    let result = this.bills.find(({ code }) => code === codeSeek);
    if (result !== null && result !== undefined) {
      // console.log("result", result);
       let hasError = result.errors.length > 1

       if (hasError !== null && hasError !== undefined)         
           return hasError;      
    }
    return false;  
  }  

  public CheckIfHasErrors(codeSeek: string): boolean {
    
    if(this.currentStep === 3)
       return true;
      
    let result = this.bills.find(({ code }) => code === codeSeek);
    if (result !== null && result !== undefined) {
     // console.log("result", result);
      let hasError = result.errors.find(
        ({ message }) => message === "No existe un PDF asignado a la factura."
      );

      let hasErrorNoContent = result.errors.find(
        ({ message }) => message.includes("El excel no contiene")
      );      
      
      if (hasError !== null && hasError !== undefined) {        
         return true;
      }  
      
      if (hasErrorNoContent !== null && hasErrorNoContent !== undefined) {        
        return true;
      }
      }
    
    return false;
  }

  ConfirmProcessAsAdmin(billCode: string){
    const swal = Swal.fire({
      title: "La factura no tiene pdf ¿Está seguro que desea procesarla?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Procesar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.resetSearch();
        this.spinner.show();

        let bill = this.bills.find((p) => p.code == billCode);
        //let billIds: number[] = [bill.id];
        const param: ProccessSingleTemporaryBill = {
          IdBill: bill.id,          
        };

        this._billService.proccessSingleTemporaryBill(param).subscribe(
          (response) => {
            if(response.status == 200){
              let indexToUpdate = this.bills.findIndex(
                (item) => item.id === bill.id
              );
              if (indexToUpdate > -1) {
                this.bills.splice(indexToUpdate, 1);
                this.bills = Object.assign([], this.bills);

                Swal.fire({
                  title: "Se procesó correctamente la factura.",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2000,
                  position: "top-end",
                });
              }             
              
            } else{
              //let message = response.message
              Swal.fire({
                title: response.message,
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
            }
            this.spinner.hide();
          })        
      }
    });
  }

  FetchModels() {
    this.bills = [];
    this.spinner.show();
    const param: TemporaryBillRQ = {
      filter: null,
    };
    this._billService.getTemporaryBillByFilterPost(param).subscribe(
      (response) => {
        let list = response;
        let errorCount = 0;
        let totalRecords = 0;
        let succesCount = 0;

        if (list) {
          totalRecords = list.length;
          list.forEach((row) => {
            let message = "";
            if (!row.isValid) {
              errorCount++;
              row.errors.forEach((errorRow) => {
                message += ` ${errorRow.message}`;
              });
            } else {
              message = "Factura registrada satisfactoriamente.";
              succesCount++;
            }

            let now: CSVBillRP = this.GetCSVBillRPFromRQ(row, message);

            this.searchBills = this.bills = this.bills.concat(now);
          });
        }
        this.canCheck = succesCount > 0;
        this.generalResults = `Vista previa de las facturas cargadas vía excel.`;
        this.alreadyRegisteredBillsMsg = `Existen ${succesCount} registros  disponibles para procesar y ${errorCount} con errores no aptos para procesamiento.`;

        this.spinner.hide();
      },
      (error) => {
        this.currentStep = 1;
        console.warn(error);
        this.spinner.hide();
      }
    );
  }

  FilterUpdate(event) {
    this.currentStep = this.currentStep === 3 ? this.currentStep : 4;
    const count = 6;
    if(this.searchBills.length > 0){
     // console.log('this.bills', this.bills)
     // console.log('this.searchBills', this.searchBills)
      const keys = Object.keys(this.searchBills[0]);
      //console.log('keys', keys)
      if (event && event !== "") {
        this.bills = this.searchBills.filter((item) => {
          // iterate through each row's column data
          for (let i = 0; i < 8; i++) {
            // check for a match
            //console.log('item',i, keys[i], item[keys[i]])
            if (
              (item[keys[i]] &&
                item[keys[i]]
                  .toString()
                  .toLowerCase()
                  .indexOf(event.toLowerCase().trim()) !== -1) ||
              !event.toLowerCase()
            ) {
              // found match, return true to add to result set
              return true;
            }
          }
        });
        //console.log('resultado', this.bills)
        //this.bills = this.searchBills.filter(x => x.code.toLowerCase().indexOf(event.toLowerCase()) > -1);
      } else {
        this.bills = this.searchBills;
      }
    }
    // get the key names of each column in the dataset
    
    this.searched = true;
  }

  GetSenderBill(bill: CSVBillRQ) {
    let sender: SenderBillModel = {
      senderName: bill.senderName,
      senderPhone: bill.senderPhone,
    };
    return sender;
  }

  GetCustomerBill(bill: CSVBillRQ) {
    let customer: CustomerBillModel = {
      customerName: bill.customerName,
      customerPhone: bill.customerPhone,
    };
    return customer;
  }

  GetIdCode(bill: CSVBillRQ) {
    let record: IdCode = {
      code: bill.code,
      id: bill.id,
    };
    return record;
  }

  GetCSVBillRPFromRQ(bill: CSVBillRQ, error: string) {
    let customerPhones = bill.customerPhone.replace("-", ", ");
    if (customerPhones.endsWith(", ")) {
      customerPhones = customerPhones.substring(0, customerPhones.length - 2);
    }

    let ret: CSVBillRP = {
      
      code: bill.code,      
      senderPhone: bill.senderPhone,
      pounds: bill.pounds,
      total: bill.total,
      createAt: bill.createAt,
      senderName: bill.senderName,   
      customerName: bill.customerName,   
      customerAddress: bill.customerAddress,
      customerPhone: customerPhones,
      agency: bill.agency,
      customerModel: this.GetCustomerBill(bill),
      senderModel: this.GetSenderBill(bill),
      employee: bill.employee,      
      id: bill.id,
      delivery: bill.delivery,      
      services: bill.services,      
      goods: bill.goods,
      paid: bill.paid,
      paidAt: bill.paidAt,            
      customerState: bill.customerState,
      customerCity: bill.customerCity,      
      errors: bill.errors,
      message: error,
      isValid: bill.isValid,
      idCode: this.GetIdCode(bill)
    };
    return ret;
  }

  Back(): void {
    if (this.currentStep == 1 || this.currentStep == 3) this._location.back();
    else {
      this.resetSearch();
      this.currentStep = 1;
      this.selectedBills = [];
      this.bills = [];
      this.alreadyRegisteredBillsMsg = "";
      this.canCheck = false;
      //this.FetchModels();
    }
  }
}
